// Generated by scripts/build-routes.mjs — do not edit by hand.
import type { BuiltinRouteData, BuiltinRouteDef } from './types';
import chasseralTerrain from './chasseral.terrain.bin?url';

export const BUILTIN_ROUTES: BuiltinRouteDef[] = [
  {
    id: 'builtin-chasseral',
    name: 'Nods – Chasseral – Nods',
    load: () => import('./chasseral.route.json').then((m) => m.default as BuiltinRouteData),
    terrainUrl: chasseralTerrain,
  },
];
